import React, { createContext, useState, useContext, useEffect } from "react";
import api from "../../api/api";
import { store } from "../../store/store";

export const StatsContext = createContext();

export const StatsContextProvider = ({ children }) => {
  const [statsData, setStatsData] = useState(0);
  const [zonalPositionData, setZonalPositionsData] = useState([]);
  const globalState = useContext(store);
  const [zoneAnlysticData, setZoneAnlysticData] = useState([]);
  const [totalMemberCount, setTotalMemberCount] = useState(0);
  const [totalPendingMemberCount, setTotalPendingMemberCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [showSMSRemiderPopup, setShowSMSRemiderPopup] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [statusModal, setStatusModal] = useState(false);
  const [reminderMessage, setReminderMessage] = useState("");
  const [modalSuccess, setModalSuccess] = useState(false);
  const [reminderMsgValidation, setReminderMsgValidation] = useState(false);
  const [modalWarning, setModalwarning] = useState(false);

  // useEffect(() => {
  //   const fetchPoll = () => {
  //     api
  //       .getStatsData(globalState.state.token)
  //       .then((response) => {
  //         if (response?.data?.statistics?.total_poll) {
  //           setStatsData(response.data.statistics.total_poll);
  //           // console.log("zonal data", response.data.statistics.positions)
  //           setZonalPositionsData(response.data.statistics.positions);
  //         }
  //       })
  //       .catch((e) => {});
  //   };

  //   fetchPoll();

  //   // const interval = setInterval(() => fetchPoll(), 1000)
  //   // return () => {
  //   //     clearInterval(interval);
  //   // }
  // }, []);
  useEffect(() => {
    getZoneWiseAnalytics();
  }, []);
  const getZoneWiseAnalytics = () => {
    api
      .getZoneWiseStatsData(globalState.state.token)
      .then((response) => {
        if (response?.data?.zoneWiseStats) {
          setZoneAnlysticData(response?.data?.zoneWiseStats);
          setTotalMemberCount(response?.data?.overall?.total_members);
          setTotalPendingMemberCount(response?.data?.overall?.total_pending);
          setTotalCount(response?.data?.overall?.total_voted);
        }
      })
      .catch((e) => {});
  };
  const sendSMSReminder = () => {
    if (reminderMessage === "") {
      setReminderMsgValidation(true);
    } else {
      // reset old states before calling API
      setShowSMSRemiderPopup(false);
      setModalwarning(false);
      setModalSuccess(false);
      setModalMessage("");
      api
        .sendSmsReminderMemberNotVoted(reminderMessage)
        .then((response) => {
          const message =
            response?.data?.msg || "Reminder SMS sent successfully";
          setModalMessage(message);
          setModalSuccess(true);
          setStatusModal(true);
        })
        .catch((error) => {
          const errorMessage =
            error?.response?.data?.message || "Message sending failed.";
          setModalMessage(errorMessage);
          setModalwarning(true);
          setStatusModal(true);
        });
    }
  };

  const handleChangeMessage = (value) => {
    if (value !== "") {
      setReminderMsgValidation(false);
    }
    setReminderMessage(value);
  };

  const handleShowModal = () => {
    setShowSMSRemiderPopup(true);
    setReminderMessage("");
    setReminderMsgValidation(false);
  };

  const handleCloseModal = () => {
    setShowSMSRemiderPopup(false);
    setModalMessage("");
  };

  const providerValue = {
    statsData,
    zonalPositionData,
    zoneAnlysticData,
    totalMemberCount,
    totalPendingMemberCount,
    sendSMSReminder,
    totalCount,
    setTotalCount,
    handleShowModal,
    showSMSRemiderPopup,
    setShowSMSRemiderPopup,
    modalMessage,
    statusModal,
    setStatusModal,
    handleCloseModal,
    handleChangeMessage,
    reminderMessage,
    reminderMsgValidation,
    setReminderMsgValidation,
    modalSuccess,
    modalWarning,
  };

  return (
    <StatsContext.Provider value={providerValue}>
      {children}
    </StatsContext.Provider>
  );
};
